module.exports = "<div style=\"height: 500px;\">\n  <p>\n    menu page  (under construction)\n  </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/products/products.component.html
// module id = ./src/app/components/products/products.component.html
// module chunks = main